import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";

function MainLayout() {

  const [isMobile, setIsMobile] =
    useState(
      window.innerWidth <= 768
    );

  const [isOpen, setIsOpen] =
    useState(
      window.innerWidth > 768
    );

  useEffect(() => {

    const handleResize =
      () => {

        const mobile =
          window.innerWidth <= 768;

        setIsMobile(mobile);

        if (mobile) {

          setIsOpen(false);

        } else {

          setIsOpen(true);

        }
      };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );

  }, []);

  const sidebarWidth =
    isMobile
      ? 0
      : (isOpen ? 240 : 70);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        overflowX: "hidden"
      }}
    >

      {/* MOBILE BUTTON */}
      {isMobile && !isOpen && (

        <button
          className="mobile-menu-btn"
          onClick={() =>
            setIsOpen(true)
          }
        >
          ☰
        </button>

      )}

      {/* SIDEBAR */}
      <Sidebar
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      {/* MAIN CONTENT */}
      <div
        className="main-content"
        style={{
          marginLeft:
            isMobile
              ? 0
              : sidebarWidth,

          width:
            isMobile
              ? "100%"
              : `calc(100% - ${sidebarWidth}px)`,

          minHeight: "100vh",

          padding:
            isMobile
              ? "12px"
              : "16px",

          transition:
            "margin-left 0.3s ease, width 0.3s ease",

          background:
            "#f8fafc",

          boxSizing:
            "border-box",

          overflowX:
            "hidden"
        }}
      >

        <Outlet />

      </div>

    </div>
  );
}

export default MainLayout;